<div class="container">
  <p class="title">{{ 'symptomAssessmentIntro.title' | translate }}</p>
  <div class="text">
    <p>{{ 'symptomAssessmentIntro.text1' | translate }}</p>
    <p>{{ 'symptomAssessmentIntro.text2' | translate }}</p>
    <p>
      <span [innerHTML]="'symptomAssessmentIntro.text3' | translate"></span>
      <a style="text-decoration: underline;" [routerLink]="['/terms-evaluation']">{{'symptomAssessmentIntro.link' | translate}}</a>
    </p>
    <span>{{ 'symptomAssessmentIntro.warning' | translate }}</span>
    <p>{{ 'symptomAssessmentIntro.text4' | translate }}</p>
    <span>{{ 'symptomAssessmentIntro.text5' | translate }}</span>
    <p>{{ 'symptomAssessmentIntro.consent' | translate }}</p>
  </div>
</div>